var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"loadingCard d-flex justify-center align-center"},[_c('v-btn',{attrs:{"loading":true,"text":"","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }